/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { LetterRestService, QuotationRestService } from '@gh/builder-shared-data';
import { InitDialogViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { DialogRouteSnapshot } from '@gh/core-ui';
import { map$ } from '@gh/rx/operators';

import { Observable } from 'rxjs';

import { QuoteStructureConfig } from '../components/lead-details/quote-structure-dialog/quote-structure-dialog.component';
import {
  QuoteStructure,
  QuoteStructurePreviewRequest,
  QuoteStructurePreviewResponse,
  structureFromDto,
  structureToDto,
} from './quote-structure.model';

@Injectable()
export class QuoteStructureBusinessService implements InitDialogViewService<QuoteStructureConfig> {
  constructor(private quotationsRest: QuotationRestService,
              private letterRest: LetterRestService) {
  }

  get(sfId: ID, quoteId: ID): Observable<QuoteStructure> {
    return this.quotationsRest.getQuoteStructure(sfId, quoteId);
  }

  initDialogView(route: DialogRouteSnapshot<QuoteStructureConfig>): any {
    const { sfId, quoteId } = route.input;

    return {
      sfId,
      quoteId,
      quoteStructure: this.get(sfId, quoteId).pipe(map$(structureFromDto)),
    };
  }

  save(sfId: ID, quoteId: ID, structure: QuoteStructure): Observable<QuoteStructure> {
    return this.quotationsRest.saveQuoteStructure(sfId, quoteId, structureToDto(structure))
      .pipe(map$(structureFromDto));
  }

  refresh(quoteId: ID): Observable<QuoteStructure> {
    return this.quotationsRest.refreshQuoteStructure(quoteId).pipe(map$(structureFromDto));
  }

  preview(request: QuoteStructurePreviewRequest): Observable<QuoteStructurePreviewResponse> {
    return this.letterRest.printQuote(request);
  }
}
